import React, { useEffect, useState } from 'react';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import heroImg from "../../../../assets/images/tlsm-model.png";
import bannerImg from "../../../../assets/images/telsim_stock_request_banner.png";
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import { ThreeDots } from 'react-loader-spinner'
import swal from 'sweetalert';
import { toast } from 'react-toastify';
// import  heroImg from "../../../../assets/images/tlsm-model.png"   
import "../TelsimStock.css";



const SERVER_URL = process.env.REACT_APP_API_URL;

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

function StockListing({ getShowCart }) {





  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addedToCart, setAddedToCart] = useState({}); // Object to track added to cart status for each plan

  const [searchPlans,setSearchPlans]=useState([])
  const[searchlength,setSearchLength]=useState("")

  // To store quantity for each plan dynamically
  const [quantities, setQuantities] = useState({});
  const [totalcount, setTotalCount] = useState("")

  const [cartData, setCartData] = useState({
    retailer_id: sessionStorage.getItem('search-ID'),
    tap_plan_id: "",
    quantity: ""
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState(""); // State for selected category
  const [categoryData, setCategoryData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Calculate total pages
  const totalPages = Math.ceil(plans.length / itemsPerPage);

  // Get the plans for the current page
  const currentPlans = plans.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };





  useEffect(() => {
    handleSearch();
    handleFetchCategories()
  }, []);

  // Fetch plans from the server
  const handleSearch = async (categoryId = "") => {
     
    try {
      setLoading(true);
      const header = await getApiHeader();  
    // Initialize URLSearchParams and append required parameters
      const params = new URLSearchParams();
      if (categoryId) {
        params.append('category_id', categoryId); // Append categoryId if provided
      }

      // Construct the URL with the query string
      const response = await axios.get(`${SERVER_URL}product-stock?${params.toString()}`, {
        headers: header
      });

      if (response.status === 200) {
        setTotalCount(response.data.data.total_cart_count);
        const data = response.data.data.products;
        setPlans(data);

        // Initialize quantities for each plan
        const initialQuantities = {};
        data.forEach(plan => {
          initialQuantities[plan.plan_id] = plan.stock_quantity; // Start with stock quantity
        });
        setQuantities(initialQuantities);
      }
    } catch (error) {
      console.error("Error in search request:", error);
    } finally {
      setLoading(false);
    }
  };


  // Increment quantity for a specific plan
  const incrementQty = (planId) => {
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty < 30) { // Limit quantity to 30
        return { ...prevQuantities, [planId]: currentQty + 1 };
      }
      return prevQuantities;
    });
  };

  // Decrement quantity for a specific plan
  const decrementQty = (planId) => {
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[planId] || 0;
      if (currentQty > 0) { // Ensure quantity does not go below 0
        return { ...prevQuantities, [planId]: currentQty - 1 };
      }
      return prevQuantities;
    });
  };

  // Get the quantity for a specific plan
  const getQuantity = (planId) => quantities[planId] || 0;

  // Handle the "Add to cart" button click
  const handleAddToCart = (planId) => {
    const quantity = getQuantity(planId); // Get the quantity for the specific plan
    console.log("Selected plan_id", planId, "Quantity:", quantity);

    if (quantity > 0) {
      // Update cartData with planId and quantity
      const updatedCartData = {
        retailer_id: sessionStorage.getItem('retailerID'),
        product_id: planId,
        quantity: quantity,
        cart_value:0,
      };
      setCartData(updatedCartData);

      // Send this `cartData` to the backend via API
      handleCart(updatedCartData, planId);
    } else {
      console.log("Quantity is zero. Cannot add to cart.");
    }
  };

  // Send the cart data to the server
  const handleCart = async (cartData, planId) => {
    try {
      const header = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}product-stock/add-to-cart`, cartData, {
        headers: header
      });

      if (response.status === 200) {
        console.log("Item added to cart", response.data.data.cart_count_total);
        setTotalCount(response.data.data.cart_count_total)

        swal({
          // title: "Sucess",
          text: response.data.data.message,
          icon: "success",
          button: "Close"
        });

        // Update `addedToCart` for the specific plan
        setAddedToCart(prevState => ({
          ...prevState,
          [planId]: true // Mark the specific plan as added to cart
        }));
      }
    } catch (error) {
      // console.error("Error adding item to cart:", error.response.data.message);
      swal("", error?.response.data.message, "warning");
    }
  };

  const handleGoToCart = async () => {
    try {

      if (!totalcount) {
        toast.error("please add items, your cart is empty")
        return
      }
      const header = await getApiHeader();

      const formData = {
        retailer_id: sessionStorage.getItem('retailerID'),
      };

      const response = await axios.post(`${SERVER_URL}product-stock/cart`, formData, { headers: header });
      if (response.status === 200) {
        getShowCart(true, response.data.data);
      }

    } catch (error) {
      console.error("Error navigating to cart:", error);
    }
  };





  const handleCategoryChange = (categoryId) => {
    setSelectedCategoryId(categoryId); // Update selected category ID
  };

  useEffect(() => {
    setCurrentPage(1)
    handleSearch(selectedCategoryId); // Fetch videos for the selected category

  }, [selectedCategoryId]);




  const handleFetchCategories = async () => {
    try {
      const headers = await getApiHeader();
      const categoryResponse = await axios.post(`${SERVER_URL}product-stock/product-category`, {}, { headers });

      if (categoryResponse?.data?.status === 200) {
        const categories = categoryResponse.data.data.telsim_stock_categories.map(item => ({
          id: item.rtap_product_category_id,
          name: item.product_category_name,
        }));
        setCategoryData(categories);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };




const handleProductSearch= async(search)=>{
  setSearchLength(search)
   if(search.length<4){
    return
   }

  try {
    const header = await getApiHeader();
    const retailer_id = sessionStorage.getItem('shop_code');
    const params = new URLSearchParams();
    params.append('retailer_id', retailer_id);
    if (search) {
      params.append('search_id', search); 
    }

    // Construct the URL with the query string
    const response = await axios.get(`${SERVER_URL}product-stock?${params.toString()}`, {
      headers: header
    });

    if (response.status === 200) {
      // setTotalCount(response.data.data.total_cart_count);
      const data = response.data.data.products;
      setSearchPlans(data);
        if(data.length<1){
          setSearchPlans([])

        }
    }
  } catch (error) {
    console.error("Error in search request:", error);
  } finally {
    setLoading(false);
  }
  
}



const handleProductIdSearch= async(product_id)=>{
   console.log("product_id",product_id)
   
  try {
    setLoading(true);
    const header = await getApiHeader();
    const retailer_id = sessionStorage.getItem('shop_code');

    // Initialize URLSearchParams and append required parameters
    const params = new URLSearchParams();
    params.append('retailer_id', retailer_id);
    if(product_id){
      params.append('product_id', product_id)
    }

    // Construct the URL with the query string
    const response = await axios.get(`${SERVER_URL}product-stock?${params.toString()}`, {
      headers: header
    });

    if (response.status === 200) {
      setTotalCount(response.data.data.total_cart_count);
      const data = response.data.data.products;
      setSearchLength("")
      setPlans(data);

      // Initialize quantities for each plan
      const initialQuantities = {};
      data.forEach(plan => {
        initialQuantities[plan.plan_id] = plan.stock_quantity; // Start with stock quantity
      });
      setQuantities(initialQuantities);
    }
  } catch (error) {
    console.error("Error in search request:", error);
  } finally {
    setLoading(false);
  }
}








  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#C11D6C"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

      <div>
        <section id="hero-2" className="hero-2 d-flex align-items-center">
          <div className="container-fluid">
            <div className="hero-border">

              <div className="hero-background">
                <img src={bannerImg} alt="" className="img-fluid banner-img" />
              </div>

            </div>
          </div>
        </section>
        <section>

        
          <div className="payment-gateway-wrapper" style={{ margin: "10px" }}>
            <div>
              <label>Please select a category to filter specific stocks :</label>
            </div>

            <div className="row" style={{ margin: "10px 0" }}>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="radio"
                    name="category"
                    id="category-all"
                    onChange={() => handleCategoryChange("")} // Empty string for "All"
                    style={{ width: "16px", height: "17px" }}
                    checked={selectedCategoryId === ""}
                  />
                  <label
                    htmlFor="category-all"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                  >
                    All
                  </label>
                </div>
              </div>
              {categoryData.map((category, index) => (
                <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      name="category"
                      id={`category-${index}`}
                      onChange={() => handleCategoryChange(category.id)} // Pass category ID
                      style={{ width: "16px", height: "17px" }}
                      checked={selectedCategoryId === category.id}
                    />
                    <label
                      htmlFor={`category-${index}`}
                      style={{ marginLeft: "10px", cursor: "pointer" }}
                    >
                      {category.name}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section style={{
          display: "flex",
          justifyContent: "flex-end", // Align to the right side of the screen
          alignItems: "center",
          paddingRight: "20px",
          position: "relative", // Position container relative for the absolute positioning of results
          width: "100%", // Make the section full width
        }}>
          {/* Search Bar */}
          <div style={{ position: "relative", display: "flex", flexDirection: "column" }}>
            <input
              type="text"
              placeholder="Search for products......."
              value={searchlength}
              style={{
                padding: "10px 40px 10px 10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                outline: "none",
                width: "350px", // Fixed width for search bar
              }}
              onChange={(e) => handleProductSearch(e.target.value)}
            />
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                color: "#aaa",
                cursor: "pointer",
                zIndex: 1000,
              }}
              onClick={() => setSearchLength("")} 
            >
              {searchlength ? (
                <i className="fa fa-times" aria-hidden="true"></i>
              ) : (
                <i className="fa fa-search" aria-hidden="true"></i>
              )}
            </span>

           

            {/* Search Results List */}
            <div style={{
              position: "absolute",
              top: "40px", 
              left: "0",
              right: "0",
              width: "350px", 
              maxHeight: "200px", 
              overflowY: "auto", 
              zIndex: 2000, 
              backgroundColor: "#fff",
              border: "1px solid #ddd",
              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              borderRadius: "5px",
              cursor: "pointer",
               
            }}>

              {searchlength && (
                <ul style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                }}>


                  {searchPlans?.map((plan, index) => (
                    <li key={index} style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                    }}
                    onClick={() => handleProductIdSearch(plan.product_id)}
                    >
                      <img
                        src={plan.product_image}
                        alt={plan.offerName}
                        style={{ width: "50px", height: "50px", borderRadius: "5px" }}
                      />
                      <span style={{ fontSize:"14px"}}>{plan.offerName}</span>
                    </li>
                  ))}
                </ul>
              )
              }
            </div>
          </div>
        </section>


        <div className='container'>
          <div>
            {totalcount > 0 && (  
            <div className="CartStck" onClick={handleGoToCart}>
              <img src="https://retailer.telsim.com.au/static/media/shopping_cart.4e5e2fa808359461355e0b74b9709094.svg" />
              <span id="CartCount">{totalcount}</span>
            </div>
            )}
          </div>
          <div className='row' style={{ borderRadius: '30px', padding: '20px', paddingBottom: '50px', }}>
            {currentPlans.map((plan, index) => (
              <div className='col-lg-4 col-md-6' key={index}>
                <div className='telsim-stock-cards'>
                  <img src={plan.product_image} alt="Telsim-stock-img" className='img-fluid telsim-stock-img' />

                  <div className='telsim-stock-name'>
                    <p style={{ fontWeight: '500' }}>{plan.offerName}</p>

                  </div>

                  <div className='flex telsim-stock-cart-sections'>
                    <div>
                      <button
                        className='telsim-stock-cart-button'
                        onClick={() => handleAddToCart(plan.product_id)}
                        disabled={getQuantity(plan.product_id) === 0}
                      >
                        {/* {addedToCart[plan.product_id] ? "Added to cart" : "Add to cart"} */}
                        Add to Cart <i class="fa fa-cart-plus" aria-hidden="true"></i>
                      </button>
                    </div>
                    <div className='control-box'>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => decrementQty(plan.product_id)}
                        disabled={getQuantity(plan.product_id) === 0}
                      >
                        -
                      </button>
                      <span className="mx-2 value-box">
                        {getQuantity(plan.product_id)}
                      </span>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => incrementQty(plan.product_id)}
                        disabled={getQuantity(plan.product_id) >= plan.stock_quantity}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className='col-lg-11' >
              {totalcount > 0 ?
                <button className="go-to-cart" onClick={handleGoToCart}>
                  View Cart <i class="fa fa-shopping-cart"></i>
                </button>
                : ""
              }
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                {currentPage > 1 && (
                  <button
                    className="pagination-button"
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    <i className="fa fa-chevron-left" aria-hidden="true"></i> Prev
                  </button>
                )}

                <button className="pagination-button active">{currentPage}</button>

                {currentPage < totalPages && (
                  <button
                    className="pagination-button"
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next <i className="fa fa-chevron-right" aria-hidden="true"></i>
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StockListing;
